import type { RouteRecordRaw } from 'vue-router'
import { i18n } from '@/shared/i18n'

export const PromotionPages = {
  list: 'ListPromotion',
  add: 'AddPromotion',
  edit: 'EditPromotion',
}

const { t } = i18n.global

const title = t('navigation.promotions')
const path = '/promotion'
const breadcrumb = [{ title, path }]

const Add: RouteRecordRaw = {
  path: 'add',
  name: PromotionPages.add,
  component: () => import('@/pages/mainPageWithRoute/promotion/AddPromotionPage.vue'),
  meta: { title: t('actions.add'), requiresAuth: true, breadcrumb },
}

const Edit: RouteRecordRaw = {
  path: ':id',
  name: PromotionPages.edit,
  component: () => import('@/pages/mainPageWithRoute/promotion/EditPromotionPage.vue'),
  meta: { title: t('actions.edit'), requiresAuth: true, breadcrumb },
}

const List: RouteRecordRaw = {
  path: '',
  name: PromotionPages.list,
  component: () => import('@/pages/mainPageWithRoute/promotion/ListPromotionPage.vue'),
  meta: { title, requiresAuth: true },
}

export const Promotions: RouteRecordRaw = {
  path,
  name: 'Promotions',
  component: () => import('@/pages/mainPageWithRoute/MainPageWithRouterView.vue'),
  meta: { title, requiresAuth: true },
  children: [Add, List, Edit],
}
